import commonAPI from "@/services/Common.js";
import Vue from 'vue';
import {
  deviceList,
  parametersList,
  getGraphData,
  getTableData,
  downloadTableData,
  getTemplate,
  setTemplate
} from "@/services/Analytics.js";
const _cloneDeep = require('lodash/fp/cloneDeep');

function initialState() {
  return {
    template: {},
    tempTemplate: {},
    device: '',
    equipmentList: [],
    deviceList: [],
    deviceIdList: {},
    parameterList: [],
    selectedParameterList: [],
    templateNameList: [],
    templateData: {},
    loadingData: false,
    graphComponentKey: 1,
    graph: {
      bar: {
        backgroundColor: null,
        title: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          }
        },
        legend: {},
        dataZoom: [{
            type: 'inside',
            xAxisIndex: 0,
            filterMode: 'empty',
            height: 10,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
          {
            type: 'inside',
            yAxisIndex: 0,
            filterMode: 'empty',
            // start: 100,
            // end: 80,
            width: 10,
            right: 50,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
          {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'empty',
            height: 10,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
          {
            type: 'slider',
            yAxisIndex: 0,
            filterMode: 'empty',
            // start: 100,
            // end: 80,
            width: 10,
            right: 50,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
        ],
        grid: {
          bottom: 90
        },
        yAxis: {
          // min: 12000,
          // max: 22000,
          scale: false,
          splitArea: {
            show: false
          },
          color: '#fff',
        },
        xAxis: {
          color: '#fff',
        }
      }
    },
    table: {
      header: [],
      data: [],
      csvHeaders: []
    },
    showUpdateDialog: false,
    showSaveDialog: false,
    dialogTitle: 'Test',
    dialogMessage: 'Testing dialog',
    selectedTemplate: '',
    dataReceived: 0
  }
}

const state = initialState()

const mutations = {
  SET_SELECTED_DEVICE(state, device) {
    state.device = device
  },
  SET_EQUIPMENT_LIST(state, equipmentList) {
    state.equipmentList = equipmentList
  },
  SET_DEVICE_LIST(state, payload) {
    const dataset = payload.deviceList.map(data => ({
      label: data.name,
      key: `${payload.deviceType}-${data.id}`,
      initial: data.real_id
    }))
    state.deviceList = dataset
  },
  SET_PARAMETER_LIST(state, parameterList) {
    state.parameterList = parameterList
  },
  SET_DEVICE_ID_LIST(state, payload) {
    if (payload.isAdd) {
      Vue.set(state.deviceIdList, payload.deviceId, {
        ...payload
      })
    } else {
      Vue.delete(state.deviceIdList, payload.deviceId)
    }
  },
  SET_PARAMETER_ID_LIST(state, payload) {
    if (payload.isAdd)
      state.selectedParameterList.push(payload.deviceId)
    else {
      let index = state.selectedParameterList.indexOf(payload.deviceId)
      state.selectedParameterList.splice(index, 1)
    }
  },
  SET_PORT_SELECTION_TO_TEMPLATE(state) {
    Object.entries(state.deviceIdList).forEach(([key, obj]) => {
      const ID = `${obj.deviceName}-${obj.id}`
      if (!state.template[ID]) {
        Vue.set(state.template, ID, {})
        Vue.set(state.template[ID], 'name', obj.deviceName)
        Vue.set(state.template[ID], 'id', obj.id)
        Vue.set(state.template[ID], 'device', obj.device)
        const param = Array.from(new Set([...state.selectedParameterList]))
        Vue.set(state.template[ID], 'param', param)


        const paramName = [];
        for (let i = 0; i < param.length; i++) {
          let foundItem = state.parameterList.find(p => (p.key == param[i]))
          if (foundItem && foundItem.label)
            paramName.push(foundItem.label)
          else
            paramName.push('-')
        }
        Vue.set(state.template[ID], 'paramName', paramName)

      } else {
        Vue.set(state.template[ID], 'param', Array.from(new Set([...state.template[ID].param, ...state.selectedParameterList])))
        const paramName = [];
        for (let i = 0; i < state.selectedParameterList.length; i++) {
          let foundItem = state.parameterList.find(p => (p.key == state.selectedParameterList[i]))
          if (foundItem && foundItem.label)
            paramName.push(foundItem.label)
          else
            paramName.push('-')
        }
        Vue.set(state.template[ID], 'paramName', Array.from(new Set([...state.template[ID].paramName, ...paramName])))

      }
    })
    state.deviceIdList = {}
    state.selectedParameterList = []
  },
  RESET_SELECTION(state) {
    state.deviceIdList = {}
    state.selectedParameterList = []
  },
  RESET_STATE(state, key) {
    const initial = initialState()
    if (key)
      state[key] = initial[key]
    else
      Object.assign(state, initial)
  },
  SET_GRAPH_DATA(state, payload) {
    state.graph.bar.legend = payload.legend;
    state.graph.bar.series = payload.series;
    state.graph.bar.xAxis = payload.xAxis[0];
    state.graphComponentKey++
  },
  SET_TABLE_DATA(state, payload) {
    state.table.header = payload.headers.map(el => {
      el['key'] = el.text
      delete el.text
      return el
    })
    state.table.data = payload.data
    state.table.csvHeaders = payload.csvHeader
    // state.graphComponentKey++
  },
  SET_GRAPH_IS_LOADING(state, isLoading) {
    state.loadingData = isLoading
  },
  SET_TEMPLATE_NAME_LIST(state, data) {
    state.templateNameList = Object.keys(data)
  },
  SET_TEMPLATE_DATA(state, data) {
    state.templateData = data
    state.template = {}
  },
  SET_SELECTED_TEMPLATE(state, templateName) {
    state.selectedTemplate = templateName
  },
  SET_SELECT_TEMPLATE(state, templateName) {
    state.template = _cloneDeep(state.templateData[templateName])
  },
  REMOVE_DEVICE_FROM_TEMPLATE(state, deviceId) {
    Vue.delete(state.template, deviceId)
  },
  REMOVE_PARAM_FROM_TEMPLATE(state, payload) {
    let {
      deviceId,
      index
    } = payload
    let paramArr = state.template[deviceId].param
    let paramNameArr = state.template[deviceId].paramName
    paramArr.splice(index, 1)
    paramNameArr.splice(index, 1)
  },
  REMOVE_TEMPLATE(state, templateName) {
    Vue.delete(state.templateData, templateName)
  },
  RESET_TEMPLATE(state) {
    state.template = {}
  },
  CLEAR_TABLE_DATA(state) {
    state.table = {
      header: [],
      data: [],
      csvHeaders: []
    }
  },
  // TODO: deep clone might be better
  CLEAR_GRAPH_DATA(state) {
    state.graph = {
      bar: {
        backgroundColor: null,
        title: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          }
        },
        legend: {},
        dataZoom: [{
            type: 'inside',
            xAxisIndex: 0,
            filterMode: 'empty',
            height: 10,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
          {
            type: 'inside',
            yAxisIndex: 0,
            filterMode: 'empty',
            // start: 100,
            // end: 80,
            width: 10,
            right: 50,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
          {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'empty',
            height: 10,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
          {
            type: 'slider',
            yAxisIndex: 0,
            filterMode: 'empty',
            // start: 100,
            // end: 80,
            width: 10,
            right: 50,
            cursor: 'pointer',
            borderColor: '#FF7247',
            borderWidth: 2,
            handleStyle: {
              borderColor: '#FF7247',
              color: '#ffffff',
              cursor: 'pointer',
            },
            handleIcon: "M409.133 109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736 9.801 259.058 0 219.273 0c-39.781 0-76.47 9.801-110.063 29.407-33.595 19.604-60.192 46.201-79.8 79.796C9.801 142.8 0 179.489 0 219.267c0 39.78 9.804 76.463 29.407 110.062 19.607 33.592 46.204 60.189 79.799 79.798 33.597 19.605 70.283 29.407 110.063 29.407s76.47-9.802 110.065-29.407c33.593-19.602 60.189-46.206 79.795-79.798 19.603-33.596 29.403-70.284 29.403-110.062.001-39.782-9.8-76.472-29.399-110.064z",
            handleSize: '250%',
            fillerColor: '#FF7247',
          },
        ],
        grid: {
          bottom: 90
        },
        yAxis: {
          // min: 12000,
          // max: 22000,
          scale: false,
          splitArea: {
            show: false
          },
          color: '#fff',
        },
        xAxis: {
          color: '#fff',
        }
      }
    }
  },
  SET_SAVE_DIALOG(state, payload) {
    state.showSaveDialog = payload
  },
  SET_UPDATE_DIALOG(state, payload) {
    state.showUpdateDialog = payload
  },
  SET_GRAPH_BACKGROUND_COLOR(state, color) {
    Vue.set(state.graph.bar, 'backgroundColor', color)
  }
}

const actions = {
  setSelectedDevice({
    commit
  }, device) {
    commit('SET_SELECTED_DEVICE', device)
  },
  fetchEquipmentList({
    commit
  }, plantId) {
    commonAPI.getDeviceList(plantId).then(res => res.data)
      .then(data => {
        let equipmentList = data.message
        commit('SET_EQUIPMENT_LIST', equipmentList)
      })
      .catch(err => console.log(err))
  },
  fetchDeviceList({
    commit
  }, param) {
    deviceList(param).then(res => res.data)
      .then(data => {
        let payload = {
          deviceType: param.device,
          deviceList: data.message
        }
        commit('SET_DEVICE_LIST', payload)
      })
      .catch(err => console.log(err))
  },
  fetchParameterList({
    commit
  }, param) {
    let param64 = btoa(JSON.stringify(param))
    parametersList(param64).then(res => res.data)
      .then(data => {
        let parameterList = data
        commit('SET_PARAMETER_LIST', parameterList)
      })
      .catch(err => console.log(err))
  },
  setDeviceIdList({
    commit
  }, payload) {
    commit('SET_DEVICE_ID_LIST', payload)
  },
  setParameterIdList({
    commit
  }, payload) {
    commit('SET_PARAMETER_ID_LIST', payload)
  },
  portSelectionToTemplate({
    commit
  }) {
    commit('SET_PORT_SELECTION_TO_TEMPLATE')
  },
  clearSelection({
    commit
  }) {
    commit('RESET_SELECTION')
  },
  resetState({
    commit
  }, payload) {
    commit('RESET_STATE', payload)
  },
  setGraphData({
    commit,
    state
  }, payload) {
    commit('SET_GRAPH_IS_LOADING', true)
    payload.query = Object.keys(state.template).map(key => state.template[key])
    getGraphData(payload).then(res => res.data)
      .then(data => {
        state.dataReceived++
        commit('SET_GRAPH_IS_LOADING', false)
        commit('SET_GRAPH_DATA', data.message)
      })
      .catch(err => {
        state.dataReceived++
        commit('SET_GRAPH_IS_LOADING', true)
        this.$router.push({'name': 'login'});
      })
  },
  downloadCSV({
    dispatch,
    state
  }, payload) {
    payload.query = Object.keys(state.template).map(key => state.template[key])
    downloadTableData(payload).then(res => {
        dispatch('downloadPrompt', {
          data: res.data
        })
      })
      .catch(err => {
        this.$router.push({'name': 'login'});
      })
  },
  downloadPrompt({}, payload) {
    const blob = new Blob([payload.data], {
      type: 'text/csv'
    })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('hidden', '')
    a.setAttribute('href', url)
    a.setAttribute('download', `${payload.name ? payload.name : 'data'}.csv`)
    document.body.appendChild(a)
    a.click();
    document.body.removeChild(a)
  },
  fetchTableData({
    commit,
    state
  }, payload) {
    payload.query = Object.keys(state.template).map(key => state.template[key])
    getTableData(payload).then(res => res.data)
      .then(data => {
        state.dataReceived++
        if (data && data.message && data.message.data)
          data.message.data = data.message.data.reverse()
        commit('SET_GRAPH_IS_LOADING', false)
        commit('SET_TABLE_DATA', data.message)
      })
      .catch(err => {
        this.$router.push({'name': 'login'});
      })

  },
  getTemplateData({
    commit
  }, plantId) {
    getTemplate(plantId).then(res => res.data)
      .then(data => {
        commit('SET_TEMPLATE_NAME_LIST', data)
        commit('SET_TEMPLATE_DATA', data)
      })
  },
  deleteTemplate({
    commit,
    dispatch,
    state
  }, payload) {
    commit('REMOVE_TEMPLATE', payload.name)
    payload.action = 'delete'
    payload.template = state.templateData

    setTemplate(payload).then(res => {
      dispatch('clearTemplate')
      dispatch('getTemplateData', payload.plantId)
    }).catch(err => console.log(err))
  },
  setTemplateData({
    commit,
    dispatch,
    state
  }, payload) {
    payload.template = Object.assign({}, state.templateData)
    payload.template[payload.name] = state.template
    setTemplate(payload).then(res => {
      dispatch('getTemplateData', payload.plantId)
      // if(payload.action === 'save' || payload.action === 'update') {
      //   commit('SET_SELECTED_TEMPLATE', payload.name)
      //   commit('SET_SELECT_TEMPLATE', payload.name)
      // } else if(payload.action === 'delete') {
      //   commit('REMOVE_TEMPLATE', '')
      // }
    })
  },
  selectTemplate({
    commit
  }, templateName) {
    commit('SET_SELECTED_TEMPLATE', templateName)
    commit('SET_SELECT_TEMPLATE', templateName)
  },
  removeDeviceFromTemplate({
    commit
  }, deviceId) {
    commit('REMOVE_DEVICE_FROM_TEMPLATE', deviceId)
  },
  removeParamFromTemplate({
    state,
    commit,
    dispatch
  }, payload) {
    console.table(payload)
    let {
      deviceId
    } = payload

    if (state.template[deviceId].param.length === 1)
      dispatch('removeDeviceFromTemplate', deviceId)
    else
      commit('REMOVE_PARAM_FROM_TEMPLATE', payload)
  },
  clearTemplate({
    commit
  }) {
    commit('SET_SELECTED_TEMPLATE', '')
    commit('RESET_TEMPLATE')
  },
  clearTableData({
    commit
  }) {
    commit('CLEAR_TABLE_DATA')
  },
  clearGraphData({
    commit
  }) {
    commit('CLEAR_GRAPH_DATA')
  },
  saveDialog({
    commit
  }, payload) {
    commit('SET_SAVE_DIALOG', payload)
  },
  updateDialog({
    commit
  }, payload) {
    commit('SET_UPDATE_DIALOG', payload)
  },
  changeGraphBackgroundColor({
    commit
  }, color) {
    commit('SET_GRAPH_BACKGROUND_COLOR', color)
  }
}

const getters = {
  getGeneralState: state => payload => {
    if (Array.isArray(payload)) {
      const rule = payload.reduce((previous, current) => {
        return previous[current]
      }, state[payload])
      return rule
    } else {
      return state[payload]
    }
  },
  isDeviceSelected: state => {
    return Object.keys(state.deviceIdList).length > 0
  },
  isParameterSelected: state => {
    return state.selectedParameterList.length > 0
  },
  isValidTemplate: state => {
    return Object.keys(state.template).length > 0
  },
  getDeviceIdList: state => {
    return Object.entries(state.deviceIdList).map(([key, device]) => device.id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}